export default __webpack_public_path__ + "static/rowSorting-3a370dddb924ef730215f5f713958519.gif";